import Navbar from "../components/Navbar";
import Footer from "../components/Footer";


function About() {
  
    
    return (
        <div className="h-auto flex flex-col bg-[#F7F7F7] ">
            <div className="sticky top-0 z-50">
                <Navbar />
            </div>
            <div className="w-full px-[7%] py-12 flex flex-col lg:gap-12 gap-8">
                <span className="lg:text-2xl text-xl font-[600] font-display underline">About Us</span>
                <span className="lg:text-xl text-base font-[400] font-display">
                    Welcome to ALIK STORE, your ultimate destination for all your online shopping needs. We are a leading
                    ecommerce company committed to providing our customers with a seamless and enjoyable shopping
                    experience. At ALIK STORE, we strive to bring you a vast selection of high-quality products from various
                    categories, all conveniently accessible from the comfort of your own needs.
                </span>

                <span className="lg:text-2xl text-xl font-[600] font-display underline">Our Vision</span>
                <span className="lg:text-xl text-base font-[400] font-display">
                    Our vision at ALIK STORE is to revolutionize the way people shop by leveraging the power of technology
                    and innovation. We aim to be the go-to online destination where customers can find everything they need,
                    ranging from everyday essentials to unique and exclusive items. We believe in the limitless potential of
                    ecommerce to bring convenience, value, and joy to people's lives.
                </span>

                <span className="lg:text-2xl text-xl font-[600] font-display underline">Wide Range of Products</span>
                <span className="lg:text-xl text-base font-[400] font-display">
                    With an extensive catalog of products, we cater to the diverse needs and preferences of our customers.
                    you'll find an incredible array of options to choose from. We carefully curate our inventory, partnering
                    with trusted suppliers and brands to ensure that every item we offer meets the highest standards of
                    quality and reliability.
                </span>

                <span className="lg:text-2xl text-xl font-[600] font-display underline">
                    User-Friendly Shopping Experience
                </span>
                <span className="lg:text-xl text-base font-[400] font-display">
                    We understand that convenience and simplicity are paramount when it comes to online shopping. Our
                    website is designed with a user-friendly interface that makes browsing and finding products a breeze.
                    Our advanced search and filtering options allow you to quickly locate the items you're looking for, and
                    our detailed product descriptions and customer reviews provide valuable insights to help you make
                    informed decisions.
                </span>

                <span className="lg:text-2xl text-xl font-[600] font-display underline">Exceptional Customer Service</span>
                <span className="lg:text-xl text-base font-[400] font-display">
                    We value each and every customer and strive to provide exceptional customer service at all times. Our
                    dedicated support team is readily available to assist you with any inquiries, concerns, or feedback you
                    may have. Whether it's assistance with order, product recommendations, or resolving any issues that may
                    arise, we are here to ensure your complete satisfaction.
                </span>

                <span className="lg:text-2xl text-xl font-[600] font-display underline">
                    Community and Social Responsibility
                </span>
                <span className="lg:text-xl text-base font-[400] font-display">
                    At ALIK STORE, we believe in giving back to the community and being socially responsible. We actively
                    seek opportunities to support charitable causes, environmental sustainability, and initiatives that make
                    a positive impact on society. By shopping with us, you become a part of this mission, as a percentage of
                    our profits goes towards supporting these endeavors.
                </span>

                <span className="lg:text-xl text-base font-[400] font-display">
                    Thank you for choosing ALIK STORE as your preferred online shopping destination. We look forward to
                    serving you and exceeding your expectations with our exceptional products, customer service, and
                    commitment to making your shopping experience truly remarkable.
                </span>

                <span className="lg:text-xl text-base font-[600] font-display text-[#8B0000]">
                    ALIK STORE, established in 2022, is one of Kerala's leading wholesalers with 25000+ buyers with
                    capabilities to deliver across 100% of serviceable PIN codes in Kerala.
                </span>
            </div>
            <div className="mt-7">
                <Footer />
            </div>
        </div>
    );
}

export default About;
